import { ScreenOrientation } from '@capacitor/screen-orientation';

import { appendAppLog } from './appLog';
import { istGeraet } from './gleis';

/**
 * Querformat erlauben oder auf Hochformat sperren (`landscape_mode`, seit 2026-10-02).
 *
 * Über `@capacitor/screen-orientation`, den Standardweg von Capacitor ([[plugin-policy]]).
 *
 * ⚠️ **Auf dem iPad wirkt das nur mit `UIRequiresFullScreen`** in `Info.plist` — ohne es lässt
 * iOS die Ausrichtung einer App, die Split View beherrscht, nicht sperren. Der Preis: Split
 * View und Slide Over gibt es für die App nicht mehr; im Prüfungsbetrieb ohnehin nicht gewollt.
 *
 * Nur auf dem Gerät. Am Desktop dreht sich nichts, im Browser entscheidet der Browser.
 *
 * ⚠️ **Wirft nicht.** Eine Ausrichtung, die sich nicht setzen lässt, ist kein Grund, den Start
 * aufzuhalten — sie steht im Dateilog.
 */
export async function setzeQuerformat(erlaubt: boolean): Promise<void> {
  if (!istGeraet()) return;
  try {
    if (erlaubt) await ScreenOrientation.unlock();
    else await ScreenOrientation.lock({ orientation: 'portrait' });
  } catch (fehler) {
    await appendAppLog('Ausrichtung setzen gescheitert: ' + String(fehler), 'warn').catch(
      () => undefined,
    );
  }
}
